export default {
  id: '79b3f4dbaf',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page no-navbar no-swipeback" data-name=login><div class="page-content login-screen-content"><div class=text-align-center style="margin-top: 100px;"><img src=./static/images/logo.png width=80% alt=""></div><h4 class=text-align-center>INFORME SEU CÓDIGO DE EXPOSITOR</h4><div class=list><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><input type=text name=username id=Usuario_email class=p-4 style="border-radius: 0; border-color: #71878e!important;"></div></div></li></ul></div><div class=row><div class=col-25></div><a href=# class="button button-fill button-rounded btnAutenticar button-lg col-50 btnCorPrincipal">Entrar</a><div class=col-25></div></div></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};